import CommonwealthFencingChampionship22 from './CommonwealthFencingChampionship22.js';

export default CommonwealthFencingChampionship22;